import { render } from "./AuctionRequestEdit.vue?vue&type=template&id=554b7bae&scoped=true"
import script from "./AuctionRequestEdit.vue?vue&type=script&lang=js"
export * from "./AuctionRequestEdit.vue?vue&type=script&lang=js"

import "./AuctionRequestEdit.vue?vue&type=style&index=0&id=554b7bae&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554b7bae"]])

export default __exports__